import { SORT_DIRECTION__ASC } from 'react-redux-app/lib/modules/table/constants';
import { CAMPAIGNS_GRID_NAME } from '../constants';

import { defaultFilter as defaultFilterBase } from '../../queryFilter/constants';

import { getGridFilterByName } from '../../queryFilter/utils/gridFilter';


export const getDefaultFilter = () => ({
  ...defaultFilterBase,
  sortField: 'name',
  sortDirection: SORT_DIRECTION__ASC,
});

export const getGridFilter = location => (
  getGridFilterByName(location, CAMPAIGNS_GRID_NAME, getDefaultFilter())
);
